"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletActionsConverter = exports.WalletActionResult = void 0;
const _1 = require(".");
/**
 * Represents the result of an action performed on the blockchain.
 *
 * This class provides details about the pagination and the list of actions
 * performed on the blockchain.
 */
class WalletActionResult {
    /**
     * Constructs a `WalletActionResult` instance.
     * @param hasNextPage Indicates if there's a next page available.
     * @param hasPrevPage Indicates if there's a previous page available.
     * @param nextPage Provides the number of the next page.
     * @param prevPage Provides the number of the previous page.
     * @param page Provides the current page number.
     * @param totalDocs Provides the total number of documents or actions.
     * @param limit Provides the limit for the number of actions per page.
     * @param totalPages Provides the total number of pages available.
     * @param pagingCounter Provides the current paging counter.
     * @param actions Provides a list of wallet actions.
     */
    constructor({ hasNextPage, hasPrevPage, nextPage, prevPage, page, totalDocs, limit, totalPages, pagingCounter, actions, }) {
        this.hasNextPage = hasNextPage;
        this.hasPrevPage = hasPrevPage;
        this.nextPage = nextPage;
        this.prevPage = prevPage;
        this.page = page;
        this.totalDocs = totalDocs;
        this.limit = limit;
        this.totalPages = totalPages;
        this.pagingCounter = pagingCounter;
        this.actions = actions;
    }
    /**
     * Creates a `WalletActionResult` object from a JSON map.
     * @param json JSON representation of a `WalletActionResult`.
     * @returns A new `WalletActionResult` instance.
     */
    static fromJson(json) {
        return new WalletActionResult({
            hasNextPage: json.hasNextPage,
            hasPrevPage: json.hasPrevPage,
            nextPage: json.nextPage,
            prevPage: json.prevPage,
            page: json.page,
            totalDocs: json.totalDocs,
            limit: json.limit,
            totalPages: json.totalPages,
            pagingCounter: json.pagingCounter,
            actions: WalletActionsConverter.fromJson(json.docs),
        });
    }
}
exports.WalletActionResult = WalletActionResult;
/**
 * Utility for converting between JSON objects and arrays of `WalletAction` objects.
 */
class WalletActionsConverter {
    /**
     * Converts a JSON array to a list of `WalletAction` objects.
     * @param json JSON array representing wallet actions.
     * @returns Array of `WalletAction` instances.
     */
    static fromJson(json) {
        return json.map((item) => _1.WalletAction.fromJson(item));
    }
    /**
     * Converts a list of `WalletAction` objects to a JSON array.
     * @param actions Array of `WalletAction` instances.
     * @returns JSON array representing the wallet actions.
     */
    static toJson(actions) {
        return actions.map((action) => action.toJson());
    }
}
exports.WalletActionsConverter = WalletActionsConverter;
